module.exports = __webpack_public_path__ + "static/media/bodax.a6f51216.png";